"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RadioButtons = _interopRequireDefault(require("../RadioButtons/RadioButtons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".checkbox-group .checkbox {\n  margin-bottom: 8px; }\n";
  const fileName = "RadioButtonGroup_RadioButtonGroup";
  const element = document.querySelector("style[data-sass-component='RadioButtonGroup_RadioButtonGroup']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const RadioButtonGroup = _ref => {
  let {
    title,
    items,
    value,
    handleCheckboxChange,
    name,
    error
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'checkbox-group'
  }, title && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-05 sia-padding-01-bottom"
  }, title), /*#__PURE__*/_react.default.createElement(_RadioButtons.default, {
    name: name,
    items: items,
    selectedValue: value,
    onChange: value => {
      handleCheckboxChange(value);
      //setFormValues('ausbildung', value);
    }
  }), error && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-07 sia-margin-01-top"
  }, error));
};
RadioButtonGroup.propTypes = {
  name: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  items: _propTypes.default.array.isRequired,
  value: _propTypes.default.object.isRequired,
  handleCheckboxChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.string
};
var _default = exports.default = RadioButtonGroup;